<template>
    <div>
        <v-btn id="tooltip" class="tooltip"></v-btn>
        <div class="div_imgXml" v-html="imgXml"></div>
    </div>
</template>

<script>
import mixinCarImage from './mixinXMLImage';
import { mapGetters } from 'vuex';
export default {
    mixins: [mixinCarImage],

    props: {
        imgXml: { type: String, required: true },
        state: Boolean,
        graphicPreSelectedData: { type: Array, default: [] }
    },
    data() {
        // we need to defined these variables because different images have different initial values
        return { xmlOriginalOpacity: 0, xmlOriginalColor: 'blue',rootElement:'', copyShoppingCart: [] };
    },
    computed: {
        ...mapGetters({
            computedShoppingCart: 'budget/getB2bCurrentShoppingCart'
        }),
    },
    watch: {
        computedShoppingCart: {
            handler: function(newValue, oldValue) {
                if(this.state) {
                    this.hoverRemove();
                    if(newValue) {
                        if(this.graphicPreSelectedData && this.graphicPreSelectedData.length > 0) {
                          this.graphicPreSelectedData.forEach(item => {
                            let itemId = item.replace(/[^0-9]/g,'');
                            itemId = parseInt(itemId);
                            this.hoverOn(itemId);
                          })
                        }
                        if(newValue.operations.repair.length > 0) {
                          newValue.operations.repair.map(item => {
                              if (item.mapId) {
                                  this.hoverOn(item.mapId)
                              }
                          })
                        } else {
                          if(newValue.operations.maintenance.length > 0) {
                            newValue.operations.maintenance.map(item => {
                                if (item.mapId) {
                                    this.hoverOn(item.mapId)
                                }
                            })
                          }
                        }
                      }
                }
            },
            immediate: false,
            deep: true
        },
        state: {
            handler: function(newValue, oldValue) {
                if(newValue == true){
                    this.copyShoppingCart = this.$store.getters['budget/getB2bCurrentShoppingCart']
                }
            },
            immediate: true,
            deep: true
        },
        copyShoppingCart: {
            handler: function(newValue, oldValue) {
                if(this.state){
                    this.hoverRemove()
                    if(newValue) {
                        setTimeout(() => {
                          if(this.graphicPreSelectedData && this.graphicPreSelectedData.length > 0) {
                            this.graphicPreSelectedData.forEach(item => {
                              let itemId = item.replace(/[^0-9]/g,'');
                              itemId = parseInt(itemId);
                              this.hoverOn(itemId);
                            })
                          }
                          if(newValue.operations.repair.length > 0) {
                            newValue.operations.repair.map(item => {
                                if (item.mapId) {
                                    this.hoverOn(item.mapId)
                                }
                            })
                          } else {
                            if(newValue.operations.maintenance.length > 0) {
                              newValue.operations.maintenance.map(item => {
                                  if (item.mapId) {
                                    this.hoverOn(item.mapId)
                                  }
                              })
                            }
                          }
                        }, 1000);
                    }
                }
            },
            immediate: false,
            deep: true
        },
        graphicPreSelectedData: {
          handler: function(newValue, oldValue) {
            if(newValue && newValue.length > 0) {
              newValue.forEach(item => {
                let itemId = item.replace(/[^0-9]/g,'');
                itemId = parseInt(itemId);
                this.hoverOn(itemId);
              })
              if(this.computedShoppingCart.operations.repair.length > 0) {
                this.computedShoppingCart.operations.repair.map(item => {
                    if (item.mapId) {
                        this.hoverOn(item.mapId)
                    }
                })
              } else {
                if(this.computedShoppingCart.operations.maintenance.length > 0) {
                  this.computedShoppingCart.operations.maintenance.map(item => {
                      if (item.mapId) {
                          this.hoverOn(item.mapId)
                      }
                  })
                }
              }
            }
            return newValue;
          },
          deep: true,
          immediate: true
        }
    },
    methods: {
        // will be called from parent with $refs
        highlightItem(itemId) {
            window.mouseoverLink(itemId);
        },
        // will be called from parent with $refs
        unlightItem(itemId) {
            window.mouseoutLink(itemId);
        },
        hoverOn(itemId){
            const hoveredRowHtmlElement = `[id*="${itemId}"]`;
            const imageElement = this.rootElement.querySelectorAll(`${hoveredRowHtmlElement} rect, ${hoveredRowHtmlElement} path, ${hoveredRowHtmlElement} polygon`);

            imageElement.forEach(element => {
                element.classList.add('fillCheck');
                element.style.fill = this.mixinCheckedColor;
                element.style.opacity = this.mixinCheckedOpacity;
            });
        },
        hoverRemove(){
            const imageElement = this.rootElement.querySelectorAll(`.fillCheck`);

            imageElement.forEach(element => {

                element.classList.remove('fillCheck');
                element.style.fill = '';
                element.style.opacity = '';
            });
        }
    },

    mounted() {
        this.rootElement = this.$el;
        window.mouseoverLink = function(id) {
            const elementSelector = `[id*="${id}"]`;
            const imageElement = this.$el.querySelectorAll(`${elementSelector} rect, ${elementSelector} path, ${elementSelector} polygon`);

            // saving original color and opacity so we can come back to these vals oun mouseout
            this.xmlOriginalColor = imageElement[0].style.fill;
            this.xmlOriginalOpacity = imageElement[0].style.opacity;

            imageElement.forEach(element => {
                element.style.fill = this.mixinHoverColor;
                element.style.opacity = this.mixinHoverOpacity;
            });
            this.$emit('item-hovered', id.toString().substring(1))
        }.bind(this);

        window.mouseoutLink = function(id) {
            const elementSelector = `[id*="${id}"]`;
            const imageElement = this.$el.querySelectorAll(`${elementSelector} rect, ${elementSelector} path, ${elementSelector} polygon`);
            imageElement.forEach(element => {
                // setting back the origin color and opacity
                element.style.fill = this.xmlOriginalColor;
                element.style.opacity = this.xmlOriginalOpacity;
            });
            this.$emit('item-hovered-out', id.toString().substring(1))
        }.bind(this);

    },
    beforeDestroy() {
        delete window.mouseoverLink;
        delete window.mouseoutLink;
    }
};
</script>

<style lang="scss" scoped>
.tooltip {
    padding: 4px 6px;
}

.div_imgXml {
    margin: 0 auto;
    width: 100%;
    background: white;
    border-radius: 18px;
    overflow: hidden;
}
</style>
